import { useEffect } from 'react';

import { useEditTargetsContext } from '@/contexts/edit-targets-context';
import { useOpeningDetails } from '@/contexts/opening-context';
import { useOpeningSlug } from '@/hooks/use-opening-slug';

export function useEditTargets() {
  const openingSlug = useOpeningSlug();
  const { opening, hiringGoal, hiringGoalEditUrl } = useOpeningDetails();
  const { setHiringGoal, setHiringGoalUrl } = useEditTargetsContext();

  useEffect(() => {
    setHiringGoalUrl(hiringGoalEditUrl);

    if (!hiringGoal) return;
    setHiringGoal({
      openingSlug,
      openingName: opening.title,
      startDate: hiringGoal.start_date,
      endDate: hiringGoal.hire_by,
      goal: hiringGoal.hire_stats.expected ?? 0,
      duration: hiringGoal.duration,
      is_current: hiringGoal.is_current,
    });
  }, [
    hiringGoal,
    setHiringGoal,
    openingSlug,
    setHiringGoalUrl,
    opening.title,
    hiringGoalEditUrl,
  ]);
}
